var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_48816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 17V23.2222C25 23.6937 24.8127 24.1459 24.4793 24.4793C24.1459 24.8127 23.6937 25 23.2222 25H10.7778C10.3063 25 9.8541 24.8127 9.5207 24.4793C9.1873 24.1459 9 23.6937 9 23.2222V17H25ZM20.5556 9C20.7913 9 21.0174 9.09365 21.1841 9.26035C21.3508 9.42705 21.4444 9.65314 21.4444 9.88889V10.7778H23.2222C23.6937 10.7778 24.1459 10.9651 24.4793 11.2985C24.8127 11.6319 25 12.0841 25 12.5556V15.2222H9V12.5556C9 12.0841 9.1873 11.6319 9.5207 11.2985C9.8541 10.9651 10.3063 10.7778 10.7778 10.7778H12.5556V9.88889C12.5556 9.65314 12.6492 9.42705 12.8159 9.26035C12.9826 9.09365 13.2087 9 13.4444 9C13.6802 9 13.9063 9.09365 14.073 9.26035C14.2397 9.42705 14.3333 9.65314 14.3333 9.88889V10.7778H19.6667V9.88889C19.6667 9.65314 19.7603 9.42705 19.927 9.26035C20.0937 9.09365 20.3198 9 20.5556 9Z",
    fill: "#214BA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_48816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBadge);
export default __webpack_public_path__ + "static/media/calendar-badge.e2283b58bfc1d7b638f49ccf6d418407.svg";
export { ForwardRef as ReactComponent };